/** Local/dev build. Replaces `environment.ts` via `ng build|serve --configuration=dev`. */
export const environment = {
  production: false,
  appName: 'ARMA AI',
  apiBaseUrl: 'https://devapi.armatech.ai/',
  kibanaBaseUrl: 'https://kibanadev.armatech.ai',
  buildVersion: '1.0.0',
  useMockAuth: false,
  useMockData: false,
  encryptionEnabled: false,
  httpResponseDelayMs: 0,
};
